import React, { memo } from "react";
import { useSlate } from "slate-react";

import { Helpers } from "../helpers";
import { NodeTypes } from "../slateTypes";

export interface IProps {
  format: string;
  children: React.ReactNode;
}
const BlockButton: React.FC<IProps> = memo(({ format, children }) => {
  const editor = useSlate();
  const isActive = Helpers.isBlockActive(editor, format);
  const isCodeActive = Helpers.isElement(editor, NodeTypes.BLOCK_CODE);
  return (
    <button
      className={`editor-toolbar__button ${isActive ? "active" : ""}`}
      onMouseDown={event => {
        event.preventDefault();
        Helpers.toggleBlock(editor, format);
      }}
      disabled={isCodeActive && format !== "code"}
    >
      {children}
    </button>
  );
});

export { BlockButton };
